import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, get } from './constants';
import theme from './theme';
import sx from './sx';
const Pagehead = styled.div.withConfig({
  displayName: "Pagehead",
  componentId: "r7ayx1-0"
})(["position:relative;padding-top:", ";padding-bottom:", ";margin-bottom:", ";border-bottom:1px solid ", ";", ";", ";"], get('space.4'), get('space.4'), get('space.4'), get('colors.border.gray'), COMMON, sx);
Pagehead.defaultProps = {
  theme
};
Pagehead.propTypes = {
  children: PropTypes.node,
  ...COMMON.propTypes,
  ...sx.propTypes
};
export default Pagehead;